import "../css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./designSystem/Navbar";
import Footer from "./designSystem/Footer";
import ScrollToTop from "./designSystem/ScrollToTop";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import MortgageBorrowCalculatorsPage from "../frontend/pages/calculators/MortgageBorrowPage";
import MortgageRepaymentCalculatorsPage from "../frontend/pages/calculators/MortgageRepaymentPage";
import MortgageOverpaymentCalculatorsPage from "../frontend/pages/calculators/OverpaymentPage";
import StampDutyPage from "../frontend/pages/calculators/StampDutyPage";
import HowMuchWillItCostPage from "../frontend/pages/calculators/HowMuchWillItCostPage";
import HowMuchCanIBorrowPage from "../frontend/pages/calculators/HowMuchCanIBorrowPage";
import EquityReleasePage from "../frontend/pages/calculators/EquityReleasePage";
import RelevantLifeTaxPage from "../frontend/pages/calculators/RelevantLifeTaxPage";
import PensionShortfallPage from "../frontend/pages/calculators/PensionShortfallPage";
import InheritanceTaxPage from "../frontend/pages/calculators/InheritanceTaxPage";
import InvestmentPage from "../frontend/pages/calculators/InvestmentPage";
import ContactUsComponent from "./components/ContactUsComponent";
import JotformWebsiteWidget from "./components/JotformWebsiteWidget";
import FindAMortgage from "./pages/FindAMortgagePage";
import InsuranceProtectionPage from "./pages/InsuranceProtectionPage";
import UsefulToolsPage from "./pages/UsefulToolsPage";
import WhoWeArePage from "./pages/WhoWeAre";
import CharityPartnerships from "./pages/CharityPartnerships";
import HonestPricing from "./pages/HonestPricing";
import BlogsPage from "./pages/BlogsPage";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          {/* Navbar can be added here if needed */}
          {/* Define application routes */}
          <Routes>
            {/* Home page route */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/*" element={<LandingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            {/* <Route path="/contact-us" element={<ContactUsPage />} /> */}
            <Route path="/find-a-mortgage" element={<FindAMortgage />} />
            <Route
              path="/insurance-protection"
              element={<InsuranceProtectionPage />}
            />
            <Route path="/useful-tools" element={<UsefulToolsPage />} />
            <Route
              path="/calculators/mortgage-repayment"
              element={<MortgageRepaymentCalculatorsPage />}
            />
            <Route path="/calculators/stamp-duty" element={<StampDutyPage />} />
            <Route path="/about-us/who-we-are" element={<WhoWeArePage />} />
            <Route path="/about-us/charity-partnerships" element={<CharityPartnerships />} />
            <Route path="/about-us/honest-pricing" element={<HonestPricing />} />
            
            
            
            {/* <Route path="/blogs" element={<BlogsPage />} /> */}
          </Routes>
          <JotformWebsiteWidget />
          <ContactUsComponent />
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
